module.exports = __webpack_public_path__ + "images/Smartsheet-3a346e.png";